import { useCurrentFiscalYear } from '@/features/search/_hooks/get-current-fiscal-year';
import { projectListSearchNuqs } from '@/features/search/_hooks/projects-search';
import { SEARCH_DEBOUNCE_MS_TIME } from '@/features/search/_utils/constants';
import { useDebouncedQueryStates } from '@/lib/nuqs';
import { parseAsInteger, parseAsString } from 'nuqs';

export const useProjectsPageSearchQueryStates = ({
  useDebounceControl = false,
}: { useDebounceControl?: boolean } = {}) => {
  const currentFiscalYear = useCurrentFiscalYear();
  const queryStates = useDebouncedQueryStates({
    keyMap: {
      ...projectListSearchNuqs(
        currentFiscalYear.data ?? currentFiscalYear.basicFiscalYear,
      ),
      // グループ検索用
      groupInProjectsOrdering: parseAsString,
      groupInProjectsPage: parseAsInteger.withDefault(1),
    },
    debounceMs: SEARCH_DEBOUNCE_MS_TIME,
    useDebounceControl,
  });
  return queryStates;
};

export type ProjectsPageSearchQueryStates = ReturnType<
  typeof useProjectsPageSearchQueryStates
>['searchQueryStates'];
